import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { projectSettingFeaturesAppEntryPoint as main } from '@atlassian/jira-spa-apps-customer-service-project-settings-features/entrypoint.tsx';

export const projectSettingFeaturesAppPageEntryPoint = createPageEntryPoint({
	main,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
